<template>
  <v-list-item :input-value="isActive" color="primary"
    class="video-conference-room">
    <v-list-item-avatar>
      <v-icon large :color="avatarColor">mdi-video-account</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="room-name">
        <span v-if="room && !room.isAdmin(currentUsername)">{{ room.name }}</span>
        <span v-if="room && room.isAdmin(currentUsername)">{{ room.name }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span color="green" v-bind="attrs" v-on="on"><span><v-icon small color="green">mdi-shield-account</v-icon></span></span>
            </template>
            <span>{{ $t('videoconf.tooltip.admin') }}</span>
          </v-tooltip>
        </span>
      </v-list-item-title>
      <v-list-item-subtitle>
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon small>mdi-calendar-clock</v-icon>
              {{ room.expireAt | formatDateLong($i18n.locale) }}
            </span>
          </template>
          <span>
            {{
              isExpired
                ? $t('videoconf.tooltip.expired')
                : $t('videoconf.tooltip.expireAt')
            }}
          </span>
        </v-tooltip>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-flex class="d-flex justify-center">
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }" style="padding-right: 5px;">
            <v-btn class="open-new-tab-btn" :disabled="isExpired"
              icon small v-on="on" @click="openInNewTab">
              <v-icon color="primary" class="ma-2">
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ $t('videoconf.tooltip.openNew') }}
          </span>
        </v-tooltip>
        &nbsp;
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-btn class="join-btn" v-show="!$vuetify.breakpoint.mobile" :disabled="isExpired || (hasJoined && !isActive)"
              icon small v-on="on" @click="joinConference">
              <v-icon :color="isActive ? 'red' : 'primary'">
                {{ actionIcon }}
              </v-icon>
            </v-btn>
          </template>
          <span>
            {{ isActive ? $t('videoconf.tooltip.hangup') : $t('videoconf.tooltip.join', { name: room.name }) }}
          </span>
        </v-tooltip>
        <OptionsContextMenu :video-conference="room"/>
      </v-flex>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import OptionsContextMenu from '@/components/video_conferences/list/item_context_menu'

export default {
  name: 'video-conference-list-item',
  components: { OptionsContextMenu },
  props: {
    room: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      activeRoom: 'videoconfer/activeRoom',
      currentUsername: 'settings/userName',
      hasJoined: 'videoConferenceOverlay/hasJoined'
    }),
    isExpired: function () {
      return Date.parse(this.room.expireAt) < Date.now()
    },
    isActive: function () {
      return this.activeRoom !== null &&
        this.activeRoom.id === this.room.id
    },
    avatarColor: function () {
      let color = 'primary'
      if (this.isExpired) {
        color = 'grey'
      } else {
        if (this.isActive) {
          color = 'teal'
        }
      }
      return color
    },
    actionIcon: function () {
      return this.isActive ? 'mdi-phone-hangup' : 'mdi-play'
    }
  },
  methods: {
    ...mapActions({
      setActiveRoom: 'videoconfer/setActiveRoom'
    }),
    joinConference: function () {
      if (this.isActive) {
        this.$emit('hangup', true)
      } else {
        this.dbg('Join video conference ', this.room.name)
        this.setActiveRoom(this.room)
      }
    },
    openInNewTab: function () {
      const url = this.room.getShortUrl(this.currentUsername)
      window.open(url, '_blank')
      this.dbg(`Open url in a new tab: ${url}`)
      this.$emit('hangup', true)
    }
  }
}
</script>

<style scoped>
</style>
